import { useState } from "react";

export default function CategoryDropDown({ handleFilter }) {
  // const [dropdown, setDropdown] = useState(false);
  const [category, setCategory] = useState("");
  const [value, setValue] = useState("");
  // const [year, setYear] = useState("");
  // const [program, setProgram] = useState("");

  const categoryList = [
    { name: "Graduation Year", value: "YEAR" },
    { name: "Program", value: "PROGRAM" },
  ];

  const yearList = [
    { name: "Year 2014", value: "2014" },
    { name: "Year 2015", value: "2015" },
    { name: "Year 2016", value: "2016" },
    { name: "Year 2017", value: "2017" },
    { name: "Year 2018", value: "2018" },
    { name: "Year 2019", value: "2019" },
    { name: "Year 2020", value: "2020" },
    { name: "Year 2021", value: "2021" },
    { name: "Year 2022", value: "2022" },
    { name: "Year 2023", value: "2023" },
  ];

  const programList = [
    { name: "Mechanical Engineering", value: "Mechanical Engineering" },
    { name: "Microbiology", value: "Microbiology" },
    { name: "Economics", value: "Economics" },
    { name: "International Relations", value: "International Relations" },
    { name: "Accounting", value: "Accounting" },
    { name: "Computer Science", value: "Computer Science" },
  ];

  const handleFilterChange = () => {
    console.log({ category, value });
    const payload = { category, value };
    handleFilter(payload);
  };

  return (
    <div className="flex">
      <div className="inline-block relative w-full">
        <select
          onChange={(e) => setCategory(e.target.value)}
          className="text-white bg-green-900 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-800 font-medium rounded-md text-sm px-4 py-2.5 text-center inline-flex items-center dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
          // className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 pt-4 pb-4 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
        >
          <option>Select category ...</option>
          {categoryList.map((item, index) => {
            return (
              <option key={index} value={item.value}>
                {item.name}
              </option>
            );
          })}
        </select>
      </div>
      {category === "YEAR" ? (
        <>
          <select
            onChange={(e) => setValue(e.target.value)}
            className="ml-4 text-white bg-green-900 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-gree-800 font-medium rounded-md text-sm px-4 py-2.5 text-center inline-flex items-center dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
          >
            <option>Select year ...</option>
            {yearList.map((item, index) => {
              return (
                <option key={index} value={item.value}>
                  {item.name}
                </option>
              );
            })}
          </select>
          <div>
            <button
              onClick={() => handleFilterChange()}
              className="ml-4 text-white bg-green-900 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-800 font-medium rounded-md text-sm px-4 py-2.5 text-center inline-flex items-center dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
            >
              Filter
            </button>
          </div>
        </>
      ) : null}
      {category === "PROGRAM" ? (
        <>
          <select
            onChange={(e) => setValue(e.target.value)}
            className="ml-4 text-white bg-green-900 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-800 font-medium rounded-md text-sm px-4 py-2.5 text-center inline-flex items-center dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
          >
            <option>Select program ...</option>
            {programList.map((item, index) => {
              return (
                <option key={index} value={item.value}>
                  {item.name}
                </option>
              );
            })}
          </select>
          <div>
            <button
              onClick={() => handleFilterChange()}
              className="ml-4 text-white bg-green-900 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-800 font-medium rounded-md text-sm px-4 py-2.5 text-center inline-flex items-center dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
            >
              Filter
            </button>
          </div>
        </>
      ) : null}
    </div>
  );
}
